const APP_NAME = 'podcast';

/**
 * Throws an error with a scoped message if the given condition is false.
 * Acts as a runtime assertion to catch invalid states early.
 *
 * @param condition - the condition to assert
 * @param message - the error message to show if the assertion fails
 *
 * @throws Error when condition is false, with a message prefixed by app name.
 *
 * @example
 * invariant(user != null, 'User must be defined');
 */
function invariant(condition: boolean, message: string): asserts condition {
  if (!condition) {
    const err = new Error(`[${APP_NAME}] ${message}`);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(err, invariant);
    }

    throw err;
  }
}

export { invariant };
